<template lang="html">
<div>
  <div v-if="rtcDebug">
    <ul>
      <li>Me:
        <code> {{ me.channel_name }} </code>
      </li>
    </ul>
    <div v-for="(peer, channel_name) in peers" :key="channel_name">
      <ul>
        <li> Peer:
          <code> {{ channel_name }} </code>
        </li>
        <li> Peer:
          <code> {{ peer.peer.channel_name }} </code>
        </li>
        <li>Caller:
          <code>{{ peer.caller }}</code>
        </li>
      </ul>
    </div>
  </div>

  <BaseError v-bind:errorMsg="errorMsg"></BaseError>
</div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import adapter from 'webrtc-adapter'
import BaseError from './BaseError'
import RTCPeer from '@/utils/RTCPeer'
import { askForMediaPermissions } from '@/utils/safari'
import {
  MMCC_RTC_SIGNAL,
  RTC_OPEN,
  RTC_CLOSE,
  RTC_MESSAGE
} from '@/utils/mmccMessageTypes.js'

export default {
  components: {
    BaseError
  },
  props: {
    rtcDebug: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      peers: {},
      errorMsg: ''
    }
  },
  computed: {
    ...mapState({
      wsMessage: state => state.websocket.message
    }),
    ...mapGetters(['me'])
  },
  watch: {
    // Hook into incoming ws messages, if we see a RTC signal,
    // dispatch it to relevant peer.
    wsMessage (newMessage) {
      if (newMessage.type &&
          newMessage.type === MMCC_RTC_SIGNAL) {
        this.onSignal(newMessage)
      }
    }
  },
  methods: {
    startCall (peers, caller) {
      peers.forEach((peer) => {
        this.$set(
          this.peers,
          peer.channel_name,
          new RTCPeer(
            peer,
            this.me,
            caller,
            this.$socket,
            this.onOpen,
            this.onClose,
            this.onMessage
          )
        )
      })
    },
    close () {
      console.log('rtc close: (disconnect all peers)')

      Object.values(this.peers).forEach((peer) => {
        peer.close()
        this.$delete(this.peers, peer.channel_name)
      })
    },
    onSignal (message) {
      console.log('WebRTC: onsignal', message)

      if (message.data.description &&
          message.data.description.type === 'offer') {
        console.log(`New peer: ${message.from.short_name}`)
        // This is a new peer requesting to connect.
        // Start RTC
        this.startCall(
          // Peers must be an array of peer objects.
          [
            {
              channel_name: message.from.channel_name,
              short_name: message.from.short_name,
              user_id: message.from.user_id
            }
          ],
          false)
      }

      this.peers[message.from.channel_name].onSignal(message)
    },
    send (data) {
      Object.values(this.peers).forEach((peer) => {
        peer.send(data)
      })
    },
    sendJson (data, excludeSender) {
      Object.values(this.peers).forEach((peer) => {
        if (!(excludeSender &&
              data.from.channel_name === peer.peer.channel_name)) {
          // Send
          peer.send(JSON.stringify(data))
        }
      })
    },
    onOpen (peer) {
      console.log('on open callback: ', peer)
      this.$emit(RTC_OPEN, peer)
    },
    onClose (peer) {
      // Remove the RTCPeer object from this.peers.
      console.log(`on close callback: ${peer.short_name} `)
      this.$delete(this.peers, peer.channel_name)
      this.$emit(RTC_CLOSE, peer)
    },
    onMessage (message) {
      const data = JSON.parse(message.data)

      // Emit event for parent component.
      this.$emit(RTC_MESSAGE, data)
    }
  },
  mounted () {
    try {
      if (adapter.browserDetails.browser === 'safari') {
        askForMediaPermissions()
      }
    } catch (error) {
      console.error('Error requesting permission: ', error)
      this.errorMsg = error
    }
  }
}
</script>
